import { EspecialidadI } from "interfaces/especialidad";

export interface infoFetchEspecialidadI {
  id: number | string;
  nombre: string;
}

class Especialidad implements EspecialidadI {
  id: number | string;
  nombre: string;

  constructor(dto: infoFetchEspecialidadI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
  }
}

export const makeEspecialidad = (infoFetch: infoFetchEspecialidadI) => {
  return new Especialidad(infoFetch);
};
